<template>
  <div class="relative min-h-screen">
    <div class="h-80 bg-bgheader w-full absolute top-0 left-0 z-0"></div>
    <div class="relative z-10 pt-10 pb-10">
      <div class="p-3">
        <h1 class="text-right text-lg font-bold mb-3 mr-2 text-white">
          جزییات سفارش مشتری
        </h1>
        <div class="max-w-md">
          <div class="p-2 max-w-5xl mx-auto space-y-5">
            <div
              class="bg-white rounded-lg shadow-md border border-gray-100 p-3 space-y-4"
            >
              <h2 class="text-sm font-bold mb-1">اطلاعات مشتری</h2>

              <!-- ردیف اول: نام مشتری و شماره مشتری -->
              <div class="flex flex-nowrap gap-4 md:gap-6 min-w-0">
                <!-- نام مشتری -->
                <div class="flex items-center gap-1 min-w-0">
                  <font-awesome-icon
                    icon="circle-user"
                    class="fa-md text-bgbutton"
                  />
                  <div class="flex gap-1 text-xs min-w-0">
                    <span class="font-bold">نام:</span>
                    <span class="truncate">{{ this.customerName }}</span>
                  </div>
                </div>

                <!-- شماره مشتری -->
                <div class="flex items-center gap-1 min-w-0">
                  <font-awesome-icon
                    icon="calendar-days"
                    class="fa-md text-bgbutton"
                  />
                  <div class="flex gap-1 text-xs min-w-0">
                    <span class="font-bold">شماره مشتری:</span>
                    <span class="truncate">{{ this.customerId }}</span>
                  </div>
                </div>
              </div>

              <!-- ردیف دوم: وضعیت سفارش و مبلغ نهایی -->
              <div class="flex flex-nowrap gap-4 md:gap-6 min-w-0">
                <!-- وضعیت سفارش -->
                <div class="flex items-center gap-1 min-w-0">
                  <font-awesome-icon
                    icon="arrows-rotate"
                    class="fa-md text-bgbutton"
                  />
                  <div class="flex gap-1 text-xs truncate min-w-0">
                    <span class="font-bold">وضعیت سفارش:</span>
                    <span class="truncate">{{ this.basketStatus_Name }}</span>
                  </div>
                </div>

                <!-- مبلغ نهایی -->
                <div class="flex items-center gap-1 flex-shrink-0">
                  <font-awesome-icon
                    icon="hashtag"
                    class="fa-md text-bgbutton"
                  />
                  <div class="flex gap-1 text-xs">
                    <span class="font-bold">مبلغ نهایی:</span>
                    <span class="text-cyan-700 font-bold">
                      {{ $helper.priceFormatter(this.totalPrice_AfterTax) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- کارت‌های محصولات -->
            <div
              class="bg-white rounded-xl p-2 shadow-md text-[12px] w-full max-w-sm mx-auto mb-3"
              v-for="product in products"
              :key="product.code"
            >
              <div class="flex">
                <!-- عکس وسط -->
                <router-link
                  :to="`/product/${product.kala_Code}`"
                  class="mb-2 relative"
                >
                  <DiscountBadge
                    :discount="product.dscnt_Percent"
                    class="top-0 -right-2 absolute"
                  />
                  <img
                    :src="product.imgUrl"
                    class="w-20 h-20 object-cover rounded"
                  />
                </router-link>

                <!-- اطلاعات محصول -->
                <div class="space-y-1 flex flex-col flex-1 mr-4">
                  <p class="truncate max-w-[150px] font-semibold text-gray-800">
                    {{ product.kala_Name || "بدون نام" }}
                  </p>
                  <p>تعداد در بسته: {{ product.pack_Value }}</p>
                  <p>
                    قیمت واحد:
                    <span class="text-green-600 font-bold">{{
                      $helper.priceFormatter(product.nerkH_WITH_TAX / 10)
                    }}</span>
                  </p>
                  <p>
                    قیمت بسته:
                    <span class="text-green-600 font-bold">{{
                      $helper.priceFormatter(
                        (product.nerkH_WITH_TAX * product.pack_Value) / 10,
                      )
                    }}</span>
                  </p>
                  <p class="text-red-600 font-bold border-t pt-1">
                    جمع کل:
                    {{
                      $helper.priceFormatter(
                        (product.pack_Value *
                          product.nerkH_WITH_TAX *
                          product.quantity) /
                          10,
                      )
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderById } from "../../API/API";
export default {
  name: "FactorReport",
  data() {
    return {
      factorId: this.$route.params.factorId,
      products: [],
      customerName: "",
      customerId: "",
      basketStatus_Name: "",
      totalPrice_AfterTax: "",
    };
  },
  created() {
    this.getOrders();
  },
  methods: {
    async getOrders() {
      this.requests = (await getOrderById(this.factorId)).data.result;
      this.customerName = this.requests.order.customerName;
      this.customerId = this.requests.order.customerId;
      this.basketStatus_Name = this.requests.order.basketStatus_Name;
      this.totalPrice_AfterTax = this.requests.order.totalPrice_AfterTax;
      this.products = this.requests.orderdetails;
    },
  },
};
</script>

<style scoped>
/* دلخواه میتونی استایل اضافه کنی */
</style>
